import type { MouseEventHandler } from "react";
import { CloseIcon } from "@icons";
import styles from "./Input.module.scss";

/**
 * 24×24 ghost X in the right slot. data-slot-box opts into the root's
 * padding trim so the 16px glyph sits where a bare right icon would.
 * tabIndex -1 keeps Tab order identical to a plain input.
 */
export const InputClearButton = ({
    onClick,
}: {
    onClick: MouseEventHandler<HTMLButtonElement>;
}) => (
    <button
        type="button"
        className={styles.clearButton}
        aria-label="Clear"
        tabIndex={-1}
        data-slot-box
        onMouseDown={(event) => event.preventDefault()}
        onClick={onClick}
    >
        <CloseIcon aria-hidden />
    </button>
);
